import React, { useMemo } from "react";

import { GeofilterSelectionElement } from "@secondcloset/fulfillment-utils";
import { Container, GroupedProvince, Label } from "./styles";
import { Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { GeofilterConstraintProvince } from "@secondcloset/types/src/_common";

interface ProvinceListProps {
  provinces: GeofilterSelectionElement[];
  countryProvinces: GeofilterConstraintProvince[];
  setConstraint: (checkedValue: string[]) => void;
}

const ProvinceList: React.FC<ProvinceListProps> = ({ provinces, countryProvinces, setConstraint }) => {
  const mappedProvinces = useMemo(() => {
    const accumulator = {} as { [key: string]: GeofilterSelectionElement[] };
    provinces
      .sort((provinceA, provinceB) => provinceA.label.localeCompare(provinceB.label))
      .forEach((province) => {
        const label = province.label;
        accumulator[label[0]] = accumulator[label[0]] || [];
        accumulator[label[0]].push(province);
      });
    return Object.entries(accumulator);
  }, [provinces]);

  const onChange = (event: CheckboxChangeEvent) => {
    const provinceIndex = countryProvinces.findIndex((province) => province.province === event.target.value);

    if (provinceIndex >= 0) {
      setConstraint(
        countryProvinces
          .filter(
            (province) =>
              (province.province !== event.target.value && !province._destroy) ||
              (province._destroy && province.province === event.target.value)
          )
          .map((province) => province.province)
      );
      return;
    }

    setConstraint([...countryProvinces.map((p) => p.province), event.target.value]);
  };

  const isChecked = (provinceElement: GeofilterSelectionElement) => {
    const province = countryProvinces.find((p) => p.province === provinceElement.value);
    if (!province) return false;
    if (province._destroy) return false;
    return true;
  };

  return (
    <Container provinceCount={mappedProvinces.length}>
      {mappedProvinces.map((province) => (
        <GroupedProvince key={province[0]}>
          <Label>{province[0]}</Label>
          <div className="provinces">
            {province[1].map((provinceElement) => (
              <Checkbox
                key={provinceElement.value}
                value={provinceElement.value}
                checked={isChecked(provinceElement)}
                onChange={onChange}
              >
                {provinceElement.label}
              </Checkbox>
            ))}
          </div>
        </GroupedProvince>
      ))}
    </Container>
  );
};

export default ProvinceList;
